import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';

export default function AvisoLegalPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-[#544E13] mb-8">Aviso legal</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-lg mb-6">
              Última actualización: {new Date().toLocaleDateString('es-ES')}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Datos identificativos</h2>
              <p className="mb-4">
                En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, 
                de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, 
                a continuación se reflejan los siguientes datos:
              </p>
              <ul className="list-none mb-4">
                <li className="mb-2"><strong>Denominación social:</strong> RESTAURAX</li>
                <li className="mb-2"><strong>Domicilio:</strong> Hospitalet de Llobregat, Barcelona, España</li>
                <li className="mb-2"><strong>Teléfono:</strong> 690 22 09 44</li>
                <li className="mb-2"><strong>Email:</strong> info@restaurax.com</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Objeto</h2>
              <p className="mb-4">
                El presente sitio web tiene por objeto facilitar al público en general el conocimiento de las 
                actividades que esta organización realiza y de los servicios que presta, en particular servicios 
                de limpieza y restauración post incendio en Barcelona y alrededores.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Condiciones de uso</h2>
              <p className="mb-4">
                La utilización del sitio web le otorga la condición de usuario, e implica la aceptación completa 
                de todas las cláusulas y condiciones de uso incluidas en las páginas:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Si no está conforme con todas y cada una de estas condiciones, absténgase de utilizar este sitio web.</li>
                <li>El acceso a este sitio web es responsabilidad exclusiva de los usuarios.</li>
                <li>El simple acceso a este sitio web no supone entablar una relación comercial entre RESTAURAX y el usuario.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Responsabilidad</h2>
              <p className="mb-4">
                RESTAURAX no se hace responsable de la información y contenidos almacenados, a título enunciativo 
                pero no limitativo, en foros, chats, generadores de blogs, comentarios, redes sociales o cualquier 
                otro medio que permita a terceros publicar contenidos de forma independiente en la página web del prestador.
              </p>
              <p className="mb-4">
                Sin embargo, y en cumplimiento de lo dispuesto en los artículos 11 y 16 de la LSSI-CE, RESTAURAX se 
                compromete a la retirada o en su caso bloqueo de aquellos contenidos que puedan afectar o contravenir 
                la legislación nacional o internacional, derechos de terceros o la moral y el orden público.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Propiedad intelectual e industrial</h2>
              <p className="mb-4">
                RESTAURAX por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e 
                industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo, 
                imágenes, sonido, audio, vídeo, software o textos; marcas o logotipos, combinaciones de colores, 
                estructura y diseño, selección de materiales usados, programas de ordenador necesarios para su 
                funcionamiento, acceso y uso, etc.).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Exclusión de garantías y responsabilidad</h2>
              <p className="mb-4">
                RESTAURAX no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza 
                que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de 
                disponibilidad del portal o la transmisión de virus o programas maliciosos o lesivos en los contenidos.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Modificaciones</h2>
              <p className="mb-4">
                RESTAURAX se reserva el derecho de efectuar sin previo aviso las modificaciones que considere 
                oportunas en su portal, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que 
                se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados 
                en su portal.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#544E13] mb-4">Legislación aplicable y jurisdicción</h2>
              <p className="mb-4">
                La relación entre RESTAURAX y el usuario se regirá por la normativa española vigente y cualquier 
                controversia se someterá a los Juzgados y tribunales de la ciudad de Barcelona.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
}